// "Filter By" values on the TR Work File browse screen (BrowseTrWorkFIleFilters.vue's
// filterList). Shared with the footer, which has to know which tab is open to decide what a
// blank From/To Mtg Code means and how to order the printed run.
export const TAX_ID_TAB = 1;
export const MTG_CODE_TAB = 2;
export const OWNER_NAME_TAB = 3;
export const EMAIL_TAB = 4;
export const PARCEL_ID_TAB = 5;
export const SELECTED_TAB = 6;

export default {
  TAX_ID_TAB,
  MTG_CODE_TAB,
  OWNER_NAME_TAB,
  EMAIL_TAB,
  PARCEL_ID_TAB,
  SELECTED_TAB,
};
